import request from '@/utils/request'

// /查询零星预测管理列
export function apiScpFcSporadicList (query) {
  return request({
    url: '/scp/scpFcSporadic/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiSporadicExport (data) {
  return request({
    url: '/scp/scpFcSporadic/export',
    method: 'post',
    data: data
  })
}

  // /修改零星预测管理
export function apiScpFcSporadic (data) {
    return request({
      url: `/scp/scpFcSporadic`,
      method: 'put',
      data: data
    })
  }

// 分页查询SOP礼品需求原始明细
export function apiGetSopGiftDemandOriginalDetailListPage (data) {
  return request({
    url: '/external/scm/getSopGiftDemandOriginalDetailListPage',
    method: 'post',
    data: data
  })
}
